/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_af89891e{overflow-x:hidden}.group_af89891e{margin:14px 8px 0 8px}.item_af89891e{margin:0}\n"}]);
export const root = "root_af89891e";
export const group = "group_af89891e";
export const item = "item_af89891e";